import axios from "axios";
import { API_ENDPOINTS, API_BASE_URL } from "../../../../js/api.js";

/**
 * Serviço de acompanhamentos do usuário logado.
 *
 * Mantém a forma do CadastroEmpresa (uma única rota dedicada) e cai
 * para a rota genérica `tca-empregador` quando a rota dedicada
 * não estiver disponível.
 */

export async function listarAcompanhamentosMe({
  token,
  page = 1,
  limit = 50,
  empresaId = null,
  busca = "",
} = {}) {
  if (!token) throw new Error("Token obrigatório");

  // 1. Tenta rota dedicada /acompanhamentos/me
  const endpointDedicado =
    typeof API_ENDPOINTS?.acompanhamentosMe === "function"
      ? API_ENDPOINTS.acompanhamentosMe()
      : API_ENDPOINTS?.acompanhamentosMe;

  if (endpointDedicado) {
    try {
      const resposta = await axios.get(endpointDedicado, {
        params: { page, limit },
        headers: { Authorization: `Bearer ${token}` },
      });
      return resposta.data;
    } catch (err) {
      /* tenta fallback abaixo */
    }
  }

  // 2. Fallback: rota tca-empregador (usada originalmente pelo projeto)
  const params = {};
  if (empresaId) params.empresa_id = empresaId;
  if (busca) params.busca = busca;
  if (page) params.page = page;
  if (limit) params.limit = limit;

  const resposta = await axios.get(`${API_BASE_URL}/tca-empregador`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return resposta.data;
}

export async function listarAcompanhamentosFallback({ token, busca, empresaId } = {}) {
  if (!token) throw new Error("Token obrigatório");
  const params = {};
  if (empresaId) params.empresa_id = empresaId;
  if (busca) params.busca = busca;

  const resposta = await axios.get(`${API_BASE_URL}/tca-empregador`, {
    params,
    headers: { Authorization: `Bearer ${token}` },
  });
  return resposta.data;
}
